/* 🤖 this file was generated by svg-to-ts */
export const fthrSend: {
    name: 'fthr-send';
    data: string;
} = {
    name: 'fthr-send',
    data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" class="feather feather-send" viewBox="0 0 24 24"><path d="M22 2 11 13M22 2l-7 20-4-9-9-4z"/></svg>`,
};
